import {Component, OnInit} from '@angular/core';
import {PriceRobotMessageService} from "../services/price-robot-message.service";
import {PriceRobotMessage} from "../services/price-robot-message";

@Component({
    selector: 'app-message-view',
    templateUrl: './message-view.component.html',
    styleUrls: ['./message-view.component.scss']
})
export class MessageViewComponent implements OnInit {
    public message: PriceRobotMessage = new PriceRobotMessage('', true);
    public messages: PriceRobotMessage[] = [];
    public i: number = 0;
    public ii: number = 0;


    constructor(private messageService: PriceRobotMessageService) {
    }

    ngOnInit(): void {
        this.messageService.getMessage().subscribe(result => {
            this.message = result;

            if (this.message.message !== '') {
                this.messages = [this.message];
            }
        });

    }

    empty(index: number) {
        this.messages[index].clear();
    }

}
